import { render, staticRenderFns } from "./ImageSymbol.vue?vue&type=template&id=2a2d721f&scoped=true&"
import script from "./ImageSymbol.vue?vue&type=script&lang=js&"
export * from "./ImageSymbol.vue?vue&type=script&lang=js&"
import style0 from "./ImageSymbol.vue?vue&type=style&index=0&id=2a2d721f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2d721f",
  null
  
)

export default component.exports